import LoginSVG from "assets/loginSVG";
import LoginLeftPanel from "./components/login-left-panel";
import { Button, Tooltip } from "@mui/material";
import { Article } from "@mui/icons-material";
import { userGuideDoc } from "utility/constants";

const LoginPage = ({ triggerLogin, requestAccess }: any) => {

    return (
        <div style={{ padding: "8px" }}>
            <div style={{ padding: "8px", display: "flex", justifyContent: "space-between" }}>
                <div style={{ padding: "8px" }}><img src="https://www.ascentt.com/wp-content/uploads/thegem-logos/logo_3ecf80c1978fe47f22d64bd6da182d45_1x.png" alt="Ascentt INC"/></div>
                <Tooltip title="Access the user guide">
                    <Button
                        variant="text"
                        startIcon={<Article />}
                        onClick={() => {
                            window.open(
                                userGuideDoc,
                                "_blank"
                            );
                        }}
                        style={{ color: "black" }}
                    >
                        User Guide
                    </Button>
                </Tooltip>
            </div>
            <div>
                <div style={{ display: "flex", justifyContent: "space-around", paddingTop: "6%" }}>
                    <div id="leftPanel" style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <LoginLeftPanel triggerLogin={triggerLogin} requestAccess={requestAccess} />
                    </div>
                    <div id="rightPanel">
                        <LoginSVG />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;